import {
    Box,
    ButtonBase,
    Stack,
    styled,
    Typography,
} from "@mui/material";
import FlexBetween from "../../components/flexbox/FlexBetween";
import FlexRowAlign from "../../components/flexbox/FlexRowAlign";
import { PrimaryButton } from "../../components/Button";
import { useEffect, useState } from "react";
import { fCurrency, shortenNumber } from "../../utils/format";
import toast from "react-hot-toast";
import useAxios from "../../hooks/useAxios";
import { useQueryClient } from "@tanstack/react-query";
import moment from "moment";
import Iconify from "../../components/Iconify";
import { openTelegramLink, openLink } from "@telegram-apps/sdk-react"

export default function PartnerQuest({ quests, POWERBalance }) {
    console.log('asdfa', quests)
    return (
        <Stack px={1} pt={2} spacing={1} sx={{ border: '1px solid #000', boxShadow: '-1px -3px 0px rgba(0,0,0,0.2)', borderRadius: '0.3rem' }}>
            <Stack spacing={1} sx={{ height: 'calc(100vh - 200px)', overflowY: 'scroll' }}>
                {
                    quests?.map((item, index) => <QuestItem key={`${index}-${item.id}`} data={item} dataIndex={index} />)
                }
            </Stack>
            <Typography><span style={{ color: '#89EC5D' }}>//</span> Complete daily tasks for daily rewards!</Typography>
        </Stack>
    );
}

const Status = {
    New: { title: 'Go', background: '#89EC5D ', key: 'Doing' },
    Processing: { title: 'Processing', background: '#F3B913', key: 'Processing' },
    Complete: { title: 'Completed', background: '#DB7424', key: 'Completed' },
    Verify: { title: 'Claim', background: '#51BA92', key: 'Verify' }
}

const QuestItem = ({ data, dataIndex }) => {
    const [isDoing, setIsDoing] = useState(false)
    const [isDone, setIsDone] = useState(false)
    const [updatedAt, setUpdatedAt] = useState(0)
    const [Process, setProcess] = useState(0) // Please not delete
    const status = isDoing === false && isDone === false ? 'New' : isDoing === true && isDone === false ? 'Verify' : 'Complete'
    const [isVerifying, setIsVerifying] = useState({});
    const [submitting, setSubmitting] = useState(false)


    const { callApi } = useAxios()
    const queryClient = useQueryClient()

    const handleDoQuest = async (item, index) => {
        if (
            isDone === false &&
            (!isDoing)
        ) {
            setSubmitting(true)
            try {
                if (item.hyperLink.startsWith('https://t.me')) {
                    openTelegramLink(item.hyperLink)
                } else if (item.hyperLink.length > 0) {
                    // @ts-ignore
                    openLink(item.hyperLink, { try_instant_view: true });
                }
                await callApi("post", "/user/do-quest", {
                    questId: item.id,
                });
                setIsDoing(true)
                setUpdatedAt(Date.now())
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    toast.error(`Error: ${error.response.data.message}`, {
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    console.log("errr", error)
                    toast.error("An unexpected error occurred.", {
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } finally {
                setSubmitting(false)
            }
        }
    };

    const handleVerifyQuest = async (item, index) => {
        setIsVerifying((prevState) => ({
            ...prevState,
            [index]: true,
        }));
        setSubmitting(true)
        try {
            await callApi("post", "/user/sucess-quest", {
                questId: item.id,
            });
            queryClient.invalidateQueries({ queryKey: ['UserBalance'] })
            setIsDone(true)
            toast.success("🎉 Quest Completed", {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (error) {
            if (error.response && error.response.status === 400) {
                toast.error(`Error: ${error.response.data.message}`, {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("An unexpected error occurred.", {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } finally {
            setIsVerifying((prevState) => ({
                ...prevState,
                [index]: false,
            }));
            setSubmitting(false)
        }
    };

    const handleAction = (key, item, index) => {
        if (key === 'Verify') {
            handleVerifyQuest(item, index)
        }
        if (key === 'Doing') {
            handleDoQuest(item, index)
        }
    }

    useEffect(() => {
        if (data) {
            setIsDoing(data?.isDoing)
            setIsDone(data?.isDone)
            setUpdatedAt(data?.updatedAt)
        }
    }, [data])

    useEffect(() => {
        let temp = 0
        const interval = setInterval(() => {
            setProcess(temp)
            temp++
        }, 1000);
        if (temp > 35) {
            clearInterval(interval)
        }
        return () => {
            clearInterval(interval)
        }
    }, [updatedAt])

    const isProcessing = isDoing == true && (parseInt(Date.now() / 1000) - moment(updatedAt).unix() <= 30)

    return <ItemContainer spacing={1} p={1} onClick={() => { handleDoQuest(data) }} >
        <FlexBetween gap={1} alignItems='flex-start'>
            <Typography>[{data.name}]</Typography>
            <ButtonBase><Iconify icon={'lineicons:arrow-angular-top-right'} size={20} sx={{ color: Status?.[status]?.background }} /></ButtonBase>
        </FlexBetween>
        <PrimaryButton disabled={submitting || Status?.[status]?.key === 'Completed' || isProcessing} onClick={() => handleAction(Status?.[status]?.key, data, dataIndex)} sx={{ px: 0.5, width: '100%', height: 30, background: Status?.[status]?.background }}>
            <Typography sx={{ color: "#000" }} variant={isProcessing ? 'caption' : 'body1'}>
                {`+${fCurrency(data?.powerAmount ?? 0)} power, +${fCurrency(data?.powerAmount ?? 0)} power capacity`}
            </Typography>
            {
                isProcessing && <Iconify icon={'svg-spinners:tadpole'} size={17} sx={{ marginLeft: '0.5rem' }} />
            }
        </PrimaryButton>
    </ItemContainer>
}

const ItemContainer = styled(Stack)(({ theme }) => ({
    border: '1px dashed #7F7F7F',
}))